import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
	currentPage: 1,
	pageSize: 10,
	queryParams: null,
	totalCount: 0
};

const setPage = (state, action) => {
	return updateObject(state, {
		currentPage: action.page
	});
};

const setPageSize = (state, action) => updateObject(state, { pageSize: action.pageSize });

const setQueryParams = (state, action) =>
	updateObject(state, {
		queryParams: action.queryParams,
		currentPage: 1,
		totalCount: 0
	});

const setTotalCount = (state, action) => {
	const totalPages = Math.ceil(action.totalCount / state.pageSize);
	let { currentPage } = state;

	if (currentPage > totalPages) {
		currentPage = totalPages;
	}
	return updateObject(state, {
		totalCount: action.totalCount,
		currentPage
	});
};

const resetPagination = () => initialState;

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.RESET_PAGINATION:
			return resetPagination(state, action);
		case actionTypes.SET_PAGINATION_PAGE:
			return setPage(state, action);
		case actionTypes.SET_PAGINATION_PAGE_SIZE:
			return setPageSize(state, action);
		case actionTypes.SET_PAGINATION_QUERY_PARAMS:
			return setQueryParams(state, action);
		case actionTypes.SET_PAGINATION_TOTAL_COUNT:
			return setTotalCount(state, action);
		default:
			return state;
	}
};

export default reducer;
